'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  if (__SERVER__) {
    // Prepend host and port of the API server to the path.
    return _config2.default.apiPath + adjustedPath;
  }
  // Prepend `/api` to relative URL, to proxy to API server.
  return '/api' + adjustedPath;
}

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */

var _ApiClient = function _ApiClient(req) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _ApiClient);

  methods.forEach(function (method) {
    return _this[method] = function (path) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          params = _ref.params,
          data = _ref.data,
          headers = _ref.headers;

      return new _promise2.default(function (resolve, reject) {
        var request = _superagent2.default[method](formatUrl(path));

        if (params) {
          request.query(params);
        }

        // if (__SERVER__ && req.get('cookie')) {
        if (__SERVER__) {
          ['cookie', 'user-agent', 'x-forwarded-for', 'x-real-ip', 'x-forwarded-proto'].map(function (key) {
            if (req.get(key)) request.set(key, req.get(key));
          });
        }

        if (headers) {
          request.set(headers);
        }

        if (__SERVER__ && req.session_id) {
          var tempObj = req.get('cookie') ? _cookie2.default.parse(req.get('cookie')) : {};
          var cookies = [];
          var cookieObj = (0, _extends3.default)({}, tempObj, { session_id: req.session_id });
          (0, _keys2.default)(cookieObj).map(function (key) {
            return cookies.push(_cookie2.default.serialize(key, cookieObj[key]));
          });
          request.set('cookie', cookies.join('; '));
        }

        if (__SERVER__ && req.unique_id) {
          request.set('X-Unique-Id', req.unique_id);
        }

        if (__SERVER__ && req.headers['x-lang']) {
          request.set('X-Lang', req.headers['x-lang']);
        }

        if (data) {
          request.send(data);
        }

        request.end(function (err) {
          var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              body = _ref2.body;

          return err ? reject(body || err) : resolve(body);
        });
      });
    };
  });
};

var ApiClient = _ApiClient;

exports.default = ApiClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClient.js
// module id = 476
// module chunks = 47